// Translations
import error from 'pages/error/translations/ua'
import login from 'pages/login/translations/ua'
import passwordChange from 'pages/error/translations/ua'
import register from 'pages/register/translations/ua'
import reset from 'pages/reset/translations/ua'
import termsOfService from 'pages/terms-of-service/translations/ua'
import twoFactorAuthentication from 'pages/two-factor-authentication/translations/ua'
import verification from 'pages/verification/translations/ua'

// Translation: Ukrainian > Pages
const pages = Object.freeze({
	error,
	login,
	passwordChange,
	register,
	reset,
	termsOfService,
	twoFactorAuthentication,
	verification
})

// Export
export default pages
